import moment from 'moment-timezone'

import { setDates, increaseMonth, appendTimeslot } from './actions'
import { apiRequest } from '../../api/actions'
import store, { dispatch } from '../../root/store'
import config from '../../config/app'

import { SCHEDULE_SUCCESS, SET_DATES } from './action-types'
import { CLINIC_TIMES_URL } from '../../api/endpoints'

const middleware = () => next => action => {
  switch (action.type) {
    case SCHEDULE_SUCCESS: {
      if (!action.meta.isGettingDates) return // only get dates if asked

      const appointments = action.payload.data.data

      if (appointments.length > 0) {
        dispatch(setDates(appointments))
      } else {
        dispatch(increaseMonth())

        const { schedule } = store.getState().containers
        const month = moment(schedule.get('month')).format()
        const meta = {
          Component: 'Schedule',
          isGettingDates: true,
          dontGetMoreDates: true
        }
        const request = { ...action.meta.originalPayload }

        request.params.month = month

        dispatch(apiRequest(request, meta))
      }

      if (action.meta.dontGetMoreDates) return next(action) // only do this once recursivly

      return next(action)
    }

    case SET_DATES: {
      const dates = action.payload
      const { app } = store.getState().containers

      if (app.get('upcomingVisit') !== null) {
        const upcomingDate = moment(app.get('upcomingVisit').date)
          .tz('America/New_York')
          .format('YYYY-MM-DD')
        let isUpcomingInDates = false
        dates.forEach(({ date }) => {
          if (upcomingDate === date) isUpcomingInDates = true
        })

        const viewedMonth = moment(dates[0].date)
          .tz('America/New_York')
          .format('YYYY-MM')

        const upcomingMonth = moment(app.get('upcomingVisit').date)
          .tz('America/New_York')
          .format('YYYY-MM')

        if (!isUpcomingInDates && upcomingMonth === viewedMonth) {
          dates.push({ date: upcomingDate })
        }
      }

      let rateLimitIndex = 0
      dates.forEach(({ date }) => {
        const request = {
          method: 'get',
          url: CLINIC_TIMES_URL,
          params: { date }
        }
        rateLimitIndex++

        const onSuccess = result => {
          const { defaultTimes } = config.schedule
          let times = []
          let longFormattedDate, month, numberOfMonth, dayName, hour, price

          if (result.data.data.length < 1) {
            result.data.data.push({ time: app.get('upcomingVisit').date })
          } // if returned empty, make a slot for the upcoming visit
          result.data.data.forEach(({ time }) => {
            const estTime = moment(time).tz('America/New_York')
            longFormattedDate = moment(estTime).format(
              'dddd, MMMM Do [at] h:mm a'
            )
            month = moment(estTime).format('MMMM YYYY')
            numberOfMonth = moment(estTime).format('DD')
            dayName = moment(estTime).format('dddd')
            hour = moment(estTime).format('h:mm a')
            price = app.get('user').visit_cost
            times.push(estTime)
            // console.log(hour)
          })

          const timeslots = [
            {
              times,
              hour,
              month,
              dayName,
              numberOfMonth,
              longFormattedDate,
              price,
              defaultTimes
            }
          ]

          // console.log('timeslots', timeslots)

          const { schedule } = store.getState().containers
          const displayedMonth = moment(schedule.get('month')).format()

          // console.log(
          //   moment(displayedMonth).format('MM'),
          //   moment(timeslots[0].times[0]).format('MM')
          // )

          const isViewedMonth =
            moment(displayedMonth).format('MM') ===
            moment(timeslots[0].times[0]).format('MM')

          if (isViewedMonth) dispatch(appendTimeslot(timeslots))
        }

        const meta = {
          assert: {
            item: date,
            throttle: 3000,
            test: 'isDate',
            hasError: false,
            error: null
          },
          onSuccess
        }

        // this is very lame but fix is later
        if (rateLimitIndex > 5 && rateLimitIndex < 10) {
          setTimeout(() => dispatch(apiRequest(request, meta)), 200)
        } else if (rateLimitIndex >= 10 && rateLimitIndex < 15) {
          setTimeout(() => dispatch(apiRequest(request, meta)), 500)
        } else if (rateLimitIndex >= 15 && rateLimitIndex < 20) {
          setTimeout(() => dispatch(apiRequest(request, meta)), 800)
        } else if (rateLimitIndex >= 20) {
          setTimeout(() => dispatch(apiRequest(request, meta)), 1100)
        } else dispatch(apiRequest(request, meta))
      })

      return next(action)
    }

    default:
      return next(action)
  }
}

export default middleware
